import React from 'react';
import { DataProvider } from "./DataHook";
import CountItem from './components/CountItem';
import { Navbar, Container, ButtonGroup } from 'react-bootstrap';
import CountUtilities from './components/CountUtilities';
import UpdateModal from './components/UpdateModal';

const items = [
  {
    name: "Beef", // Name of item
    id: "", // Item Id
    bag: 5, // Unit of item in one bag
    box: 8, // Amount of bags in a box
    unit: ["lb", "lbs"], // Unit; [singular, plural]
    color: "#753d00"
  },
  {
    name: "Steak",
    id: "",
    bag: 1.25,
    box: 32,
    unit: ["lb", "lbs"],
    // color: "#00ffe5"
    color: "#000000"
  },
  {
    name: "Chicken",
    id: "",
    bag: 1.25,
    box: 32,
    unit: ["lb", "lbs"],
    color: "#00ff2a"
  },
  // {
  //   name: "Shredded Chicken",
  //   id: "",
  //   bag: 1.25,
  //   box: 32,
  //   unit: ["lb", "lbs"],
  //   color: "#f200ff"
  // },
  {
    name: "Cheddar Cheese",
    id: "",
    bag: 5,
    box: 6,
    unit: ["lb", "lbs"],
    color: "#ff9d00"
  },
  {
    name: "Three Cheese Blend",
    id: "",
    bag: 5,
    box: 6,
    unit: ["lb", "lbs"],
    color: "#fff700"
  }
];

function App() {
  return (
    <DataProvider>
      <div className="App">
        <UpdateModal />
        <Navbar bg="light" expand="lg">
          <Container fluid>
            <Navbar.Brand href="#home">
              <img src="https://media.discordapp.net/attachments/681652195728556129/738952277754380318/sticker.png"
                width="30" height="30" className="d-inline-block align-top" alt="" loading="lazy" />
                Inventory Counts</Navbar.Brand>
          </Container>
        </Navbar>

        <div className="items">
          <Container id="items" fluid>
            {items.map(i => {
              return <CountItem {...i} key={i.name} />
            })}
          </Container>
        </div>

        <CountUtilities />
      </div>
    </DataProvider>
  );
}

export default App;
